// Deterrent against casual image saving: no context menu or drag on images. Not real protection (the file is still served to the browser).
(function () {
  const isImg = e => e.target && e.target.closest && e.target.closest('img, picture');
  document.addEventListener('contextmenu', e => { if (isImg(e)) e.preventDefault(); });
  document.addEventListener('dragstart', e => { if (isImg(e)) e.preventDefault(); });
})();
